import { defineStore } from 'pinia'

export const useFlashStore = defineStore('flash', () => {
    const body = ref('')
    const type = ref(null)
    const is_visible = ref(false)

    const show = (message, flash_type) => {
        type.value = flash_type || 'success'

        body.value = message

        is_visible.value = true
    }

    const hide = name => {
        is_visible.value = false

        body.value = ''
    }

    return {
        body,
        type,
        is_visible,
        show,
        hide,
    }
})
